import { faStore } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { createFragmentContainer, graphql } from "react-relay";
import styled from "styled-components";
import Selector from "../../AccountSelector/AccountSelector";
import UserDropdownBase from "../../UserDropdown/UserDropdown";
import Spacer from "../../Spacer";
import { Header_viewer } from "./__generated__/Header_viewer.graphql";
import { routes } from "../../../routes";
import { useRouter } from "found";
import LogoIcon from "../../LogoIcon";
import { Header_account } from "./__generated__/Header_account.graphql";
import ContentCenterer from "../../ContentCenterer";
import { isNewPartner, setPartnerStatus } from "../../../helpers";

const Container = styled.div`
  padding: 0px 0px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #5c6ef8;
  height: 68px;
`;

const AccountSelector = styled(Selector)`
  width: 300px;
`;

const UserDropdown = styled(UserDropdownBase)``;

const RightItems = styled.div`
  display: flex;
  align-items: center;
`;

const ApiManagerIcon = styled.div<{ selected: boolean }>`
  border-radius: 100%;
  display: flex;
  justify-content: center;
  position: relative;
  align-items: center;
  width: 37px;
  height: 37px;
  transition: all 0.3s;
  cursor: pointer;
  ${(props) => (props.selected ? `background: #ffffff12;` : "")}
  &:hover {
    background: #ffffff12;
  }
`;

const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1400px;
  width: 100%;
  padding: 0px 0px;
`;

const Logo = styled.div`
  cursor: pointer;
  padding: 8px 4px;
  border-radius: 6px;
  transition: all 0.1s;
  &:hover {
    background: #ffffff12;
  }
`;

const AlertBlob = styled.div`
  position: absolute;
  width: 10px;
  height: 10px;
  top: 0;
  background: #1af7db;
  border-radius: 100%;
  right: 0px;
`;

type Props = {
  children?: React.ReactNode;
  viewer: Header_viewer;
  account?: Header_account;
};

export function HeaderComponent({ children, viewer, account }: Props) {
  const { router, match } = useRouter();
  const isAPIManager = match.location.pathname.includes("api_manager");

  return (
    <Container>
      <ContentCenterer>
        <Content>
          <Logo onClick={() => router.push(routes.home)}>
            <LogoIcon height={"20px"} color={"white"} />
          </Logo>
          <RightItems>
            {viewer.userAccounts && (
              <AccountSelector
                account={account}
                subheading={viewer.email}
                accounts={viewer.userAccounts}
              />
            )}
            <Spacer horizontal spacing={2} />
            {(account?.merchant || isNewPartner()) && (
              <ApiManagerIcon
                selected={isAPIManager}
                onClick={() => {
                  setPartnerStatus(false);
                  router.push(isAPIManager ? routes.home : routes.apis);
                }}
              >
                <FontAwesomeIcon icon={faStore} color="#DEE1FF" />
                {isNewPartner() && <AlertBlob />}
              </ApiManagerIcon>
            )}
            <Spacer horizontal spacing={2} />
            <UserDropdown user={viewer} />
          </RightItems>
        </Content>
      </ContentCenterer>
    </Container>
  );
}

export default createFragmentContainer(HeaderComponent, {
  viewer: graphql`
    fragment Header_viewer on User {
      id
      email
      userAccounts {
        ...AccountSelector_accounts
      }
      ...UserDropdown_user
    }
  `,
  account: graphql`
    fragment Header_account on Account {
      ...AccountSelector_account
      merchant {
        payments {
          stripeSetupStatus
        }
      }
    }
  `,
});
